<div class="app-root" [class.share-route]="isShareRoute()" [class.legal-route]="isLegalRoute()" [class.has-banner]="((!siteStatus.showMaintenanceOverlay() || isAuthRoute()) && (siteStatus.banners().length || siteStatus.showMaintenanceBanner())) || showBillingPastDueBanner()" [style.--banner-height]="bannerHeight() + 'px'">
  <!-- Site banners (when not in maintenance overlay) -->
  @if (!siteStatus.showMaintenanceOverlay() && siteStatus.banners().length) {
    <div class="site-banners">
      @for (b of siteStatus.banners(); track b.id) {
        <div class="banner" [class]="'banner-' + b.style">{{ b.message }}</div>
      }
    </div>
  }

  <!-- Past-due billing warning for billing admins: suspension must never be a surprise -->
  @if (showBillingPastDueBanner()) {
    <div class="site-banners billing-past-due-banner">
      <div class="banner banner-warning">
        <mat-icon>warning</mat-icon>
        An invoice is {{ billingDaysOverdue() }} day{{ billingDaysOverdue() === 1 ? '' : 's' }} overdue —
        the workspace will be suspended if it stays unpaid.
        <a routerLink="/dashboard/admin/billing">Review billing</a>
      </div>
    </div>
  }

  <!-- Maintenance banner for staff (when maintenance is on but they can bypass overlay) -->
  @if (siteStatus.showMaintenanceBanner()) {
    <div class="site-banners maintenance-banner">
      <div class="banner banner-warning">
        <mat-icon>construction</mat-icon>
        Site in maintenance mode — {{ siteStatus.maintenanceMessage() || "We're making improvements. Thank you for your patience." }}
      </div>
    </div>
  }

  <main class="main-area">
    <router-outlet />
  </main>

  <!-- Cookie consent: banner when no choice yet, modal when Customise clicked (always mounted for modal access from Cookies page) -->
  <app-cookie-consent-banner />

  <!-- Footer on public pages (auth, legal, share) -->
  @if (showFooter()) {
    <app-footer />
  }

  <!-- Maintenance overlay - blocks entire app for non-staff. Never shown on auth routes so staff can sign in. -->
  @if (siteStatus.showMaintenanceOverlay() && !isAuthRoute()) {
    <div class="maintenance-overlay">
      <div class="maintenance-card">
        <mat-icon class="maintenance-icon">construction</mat-icon>
        <h1>Site under maintenance</h1>
        <p class="maintenance-message">{{ siteStatus.maintenanceMessage() || "We're making improvements to serve you better. Please check back in a few minutes." }}</p>
        <p class="maintenance-footer">Thank you for your patience</p>
      </div>
    </div>
  }

  <!-- Chat Bubble - hidden on messages route -->
  @if (showChatBubble() && !siteStatus.showMaintenanceOverlay()) {
    <app-chat-bubble />
  }

  <!-- Global card_required 402 modal (billing admins only — see auth-interceptor.ts) -->
  <app-card-required-modal />
</div>
